import { render, staticRenderFns } from "./honor-chunk.vue?vue&type=template&id=468046ee&scoped=true"
import script from "./honor-chunk.vue?vue&type=script&lang=js"
export * from "./honor-chunk.vue?vue&type=script&lang=js"
import style0 from "./honor-chunk.vue?vue&type=style&index=0&id=468046ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468046ee",
  null
  
)

export default component.exports